export const styles = {
	topbar:
		'sticky top-0 z-10 flex items-center justify-between gap-md border-b border-subtle bg-white/95 px-xl py-sm backdrop-blur',
	content: 'flex max-w-[1400px] flex-col gap-xl px-xl py-lg',
	pageEyebrow: 'mb-2xs text-[11px] font-medium uppercase tracking-wider text-purple-700',
	pageH1: 'text-[26px] font-semibold leading-tight tracking-tight text-default',
	pageSub: 'mt-3xs text-[13px] text-subtle',
	rangeToggle: 'inline-flex items-center gap-3xs rounded-md border border-subtle bg-white p-3xs',
	rangeBtn: 'rounded-md px-sm py-3xs text-[12px] font-medium transition-colors',
	rangeBtnActive: 'bg-grey-600 text-white',
	rangeBtnIdle: 'text-subtle hover:bg-grey-25',
	statGrid: 'grid grid-cols-2 gap-x-lg gap-y-md border-y border-subtle py-lg md:grid-cols-5',
	stat: 'relative flex flex-col gap-2xs',
	statLabel: 'flex items-center gap-3xs text-[11px] font-medium tracking-wide text-subtle',
	statValue: 'text-[26px] font-semibold leading-none tracking-tight tabular-nums text-default',
	statValueBrand: 'text-[26px] font-semibold leading-none tracking-tight tabular-nums text-purple-700',
	statSpark: 'absolute right-0 top-0 h-xl w-[48px] opacity-60',
	deltaUp: 'text-[11px] font-medium tabular-nums text-success',
	deltaDown: 'text-[11px] font-medium tabular-nums text-error',
	deltaFlat: 'text-[11px] font-medium tabular-nums text-subtle',
	sectionH: 'text-[15px] font-semibold leading-tight tracking-tight text-default',
	sectionSub: 'mt-3xs text-[12px] text-subtle',
	tableHeader: 'text-[10px] font-medium uppercase tracking-wider text-subtle',
	tableCell: 'text-[13px] text-default',
	tableCellMuted: 'text-[13px] text-subtle',
	userAvatar:
		'inline-flex h-xl w-xl shrink-0 items-center justify-center rounded-full border border-subtle bg-grey-25 text-[10px] font-semibold leading-none text-default',
	statusActive: 'inline-flex items-center gap-3xs text-[12px] text-default',
	statusClosed: 'inline-flex items-center text-[12px] text-subtle',
	statusHandoff:
		'inline-flex items-center gap-3xs rounded-md bg-surface-warning px-2xs py-3xs text-[11px] font-medium leading-none text-warning',
	statusError:
		'inline-flex items-center gap-3xs rounded-md bg-surface-error px-2xs py-3xs text-[11px] font-medium leading-none text-error',
	dotSuccess: 'inline-block h-2xs w-2xs rounded-full bg-green-500',
	dotDanger: 'inline-block h-2xs w-2xs rounded-full bg-red-600',
};
